class CompareProduct {
  constructor() {
    this.storageKey = 'bt-compare-products';
    this.products = [];
    this.productNodes = {};

    this.pageTemplate = 'page.product-compare';
    this.addedClass = 'bt-added-to-compare';
    this.selectors = {
      container: '.bt-compare-page-content__wrapper',
      noProducts: '.bt-compare-no-products',
      wrapper: '.bt-compare-card',
      productCard: '.bt-card-product-wrapper',
      compareButton: '.bt-product-compare-btn',
      compareText: '.bt-compare-button-text',
      removeButton: '.bt-compare-remove-button',
      count: '.bt-compare-count',
      skeleton: '.bt-product-skeleton',

      compareBar: '#bt-compare-bar',
      compareBarList: '.bt-compare-bar__list',
      compareBarItem: '.bt-compare-bar__item',
      compareBarClear: '.bt-compare-bar__clear',
      collapseCompareBarBtn: '.bt-collapse-compare-bar-btn',
      expandCompareBarBtn: '.bt-expand-compare-bar-btn',
    };

    this.removeIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>`;

    this.products = Array.from(new Set(Array.from(JSON.parse(localStorage.getItem(this.storageKey)) || [])));
    this.isComparePage = UtenzoSettings.template === this.pageTemplate;

    this.init();
  }

  init = () => {
    if (this.isComparePage) {
      this.renderComparePage();
      this.addEventToRemoveButtons();
    }

    this.setCompareButtonsState();
    this.addEventToCompareButtons();
    this.updateCompareCount();

    this.initCompareBar();
  };

  saveToStorage = () => {
    this.products = Array.from(new Set(this.products));
    localStorage.setItem(this.storageKey, JSON.stringify(this.products));
  };

  addToCompare(handle) {
    if (handle && this.products.indexOf(handle) === -1) {
      if (this.products.length >= 3) {
        UtenzoTheme.Notification.show({
          type: 'warning',
          message: 'You can only compare up to 3 products.',
        });
        return false;
      }
      this.products.push(handle);
      this.saveToStorage();
      this.addProductToBar(handle);
      return true;
    }
    return false;
  }

  removeFromCompare(handle) {
    this.products = this.products.filter((hdl) => hdl !== handle);
    this.saveToStorage();

    if (!this.isComparePage) {
      this.removeProductFromBar(handle);
    }
  }

  setCompareButtonsState = () => {
    const buttons = document.querySelectorAll(this.selectors.compareButton);
    buttons.forEach((btn) => {
      const prodHandle = btn && btn.dataset.productHandle;
      if (this.products.indexOf(prodHandle) >= 0 && btn && !btn.classList.contains(this.addedClass)) {
        this.toggleButtonState(btn, true, false);
      }
    });
  };

  removeAddedClassForAllCompareBtn = () => {
    const buttons = document.querySelectorAll(this.selectors.compareButton);
    buttons.forEach((btn) => {
      if (btn && btn.classList.contains(this.addedClass)) {
        btn.classList.remove(this.addedClass);
      }
    });
  };

  updateCompareCount = () => {
    const size = this.products.length;
    const countElems = document.querySelectorAll(this.selectors.count);
    [...countElems].forEach((elem) => {
      elem.textContent = size;
      if (size < 1) {
        elem.classList.add('hidden');
      } else {
        elem.classList.remove('hidden');
      }
    });

    // Update bar visibility
    const compareBar = document.querySelector(this.selectors.compareBar);
    if (compareBar) {
      if (size > 0) {
        compareBar.classList.add('is-visible');
      } else {
        compareBar.classList.remove('is-visible');
      }
    }
  };

  addEventToCompareButtons = () => {
    addEventDelegate({
      selector: this.selectors.compareButton,
      handler: async (e, btn) => {
        e.preventDefault();

        if (btn.disabled) return;
        btn.disabled = true;

        const productHandle = btn && btn.dataset.productHandle;
        if (productHandle) {
          const active = !btn.classList.contains(this.addedClass);
          if (this.toggleButtonState(btn, active, true)) {
            this.updateCompareCount();
            document
              .querySelectorAll(`${this.selectors.compareButton}[data-product-handle="${productHandle}"]`)
              .forEach((btnItem) => {
                if (btnItem !== btn) {
                  this.toggleButtonState(btnItem, active, false);
                }
              });

            if (this.compareBar && !this.compareBar.classList.contains('is-expanded')) {
              this.compareBar.classList.add('is-expanded');
            }
          }
        }

        // Add timeout before re-enabling button to prevent rapid clicks
        setTimeout(() => {
          btn.disabled = false;
        }, 500); // 500ms delay
      },
    });
  };

  toggleButtonState = (btn, active, performAction = true) => {
    const productHandle = btn && btn.dataset.productHandle;
    const compareText = btn && btn.querySelector(this.selectors.compareText);
    let actionResult = true;

    if (active) {
      if (performAction) {
        actionResult = this.addToCompare(productHandle);
      }
      if (actionResult) btn.classList.add(this.addedClass);
    } else {
      if (performAction) this.removeFromCompare(productHandle);
      btn.classList.remove(this.addedClass);
    }

    if (compareText && actionResult) {
      const temp = compareText.dataset.revertText;
      compareText.dataset.revertText = compareText.textContent;
      compareText.textContent = temp;
    }

    return actionResult;
  };

  addEventToRemoveButtons = () => {
    addEventDelegate({
      selector: this.selectors.removeButton,
      handler: (e, btn) => {
        e.preventDefault();
        const prod = btn && btn.closest(this.selectors.wrapper);
        prod && prod.remove();

        const productHandle = btn && btn.dataset.productHandle;
        if (productHandle) {
          this.removeFromCompare(productHandle);
          this.setCompareButtonsState();
          this.updateCompareCount();

          if (!this.products.length) {
            this.showNoProductsMessage();
          } else {
            this.addMoreItems();
          }

          // Synchronize heights after removing a product
          setTimeout(() => {
            this.synchronizeAttributeHeights();
          }, 100);
        }
      },
    });
  };

  renderComparePage = async () => {
    const container = document.querySelector(this.selectors.container);
    const skeleton = document.querySelectorAll(this.selectors.skeleton);
    if (container) {
      let noItemAvailable = true;

      if (this.products.length) {
        const promises = this.products.map(async (hdl) => {
          const prodHTML = await fetchCache(`/products/${hdl}?view=compare-item`);
          const item = document.createElement('li');
          item.classList.add('hidden', 'bt-compare-card', 'grid__item');
          item.innerHTML = prodHTML;
          if (item.querySelector(this.selectors.productCard)) {
            noItemAvailable = false;
            this.productNodes[hdl] = item;
          }
        });

        await Promise.all(promises);

        skeleton.forEach((item) => {
          item.remove();
        });
        this.products.forEach((hdl) => {
          const prodNode = this.productNodes[hdl];
          if (prodNode) {
            container.querySelector('ul').appendChild(prodNode);
            prodNode.classList.remove('hidden');
          }
        });

        this.addMoreItems();
      }

      if (noItemAvailable) {
        this.showNoProductsMessage();
      }

      container.classList.add('is-visible');

      // Synchronize attribute heights after rendering
      setTimeout(() => {
        this.synchronizeAttributeHeights();
      }, 100);
    }
  };

  showNoProductsMessage = () => {
    const container = document.querySelector(this.selectors.container);
    const noProducts = document.querySelector(this.selectors.noProducts);

    container.classList.add('hidden');
    noProducts.classList.remove('hidden');
  };

  addMoreItems = () => {
    const container = document.querySelector(this.selectors.container);
    if (!container) return;

    // Remove existing "add more" items first
    const existingAddMoreItems = container.querySelectorAll('.bt-add-more-item');
    existingAddMoreItems.forEach((item) => item.closest('.bt-compare-card').remove());

    // Add new "add more" items to fill up to 3 slots
    const itemsToAdd = 3 - this.products.length;
    for (let i = 0; i < itemsToAdd; i++) {
      const addMoreItem = document.createElement('li');
      addMoreItem.classList.add('bt-compare-card', 'grid__item', 'item-add-more');
      addMoreItem.innerHTML = `
        <div class="bt-card-product-wrapper">
        <div class="bt-card-images">
          <a href="/collections/all">
            <div class="bt-add-more-item">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
              <span>Add Product To Compare</span>
            </div>
          </a>
        </div>
        <div class="bt-card-content card__content">
          <div class="product-card__title">
          </div>
          <div class="product-card__attributes">
            <div class="product-attribute">
            </div>
            <div class="product-attribute">
            </div>
            <div class="product-attribute">
            </div>
            <div class="product-attribute">
            </div>
            <div class="product-attribute">
            </div>
          </div>
        </div>
        </div>
      `;
      container.querySelector('ul').appendChild(addMoreItem);
    }

    // Synchronize attribute heights after adding items
    this.synchronizeAttributeHeights();
  };

  synchronizeAttributeHeights = () => {
    const container = document.querySelector(this.selectors.container);
    if (!container) return;

    // Get all product cards (excluding "add more" items)
    const productCards = container.querySelectorAll('.bt-compare-card');
    if (productCards.length === 0) return;

    // Reset all heights first
    productCards.forEach((card) => {
      const attributes = card.querySelectorAll('.product-attribute');
      attributes.forEach((attr) => {
        attr.style.height = 'auto';
      });
    });

    // Find the maximum number of attributes in any product
    let maxAttributes = 0;
    productCards.forEach((card) => {
      const attributeCount = card.querySelectorAll('.product-attribute').length;
      maxAttributes = Math.max(maxAttributes, attributeCount);
    });

    // For each attribute position, find the maximum height and apply it
    for (let i = 0; i < maxAttributes; i++) {
      let maxHeight = 0;
      const attributesAtPosition = [];

      // Collect all attributes at this position and find max height
      productCards.forEach((card) => {
        const attribute = card.querySelector(`.product-attribute:nth-child(${i + 1})`);
        if (attribute) {
          attributesAtPosition.push(attribute);
          const height = attribute.getBoundingClientRect().height;
          maxHeight = Math.max(maxHeight, height);
        }
      });

      // Apply the max height to all attributes at this position
      attributesAtPosition.forEach((attribute) => {
        attribute.style.height = `${maxHeight}px`;
      });
    }
  };

  initCompareBar = () => {
    this.compareBar = document.querySelector(this.selectors.compareBar);
    if (!this.compareBar) return;

    this.compareBarList = this.compareBar.querySelector(this.selectors.compareBarList);

    this.renderCompareBar();
    this.addEventToBarButtons();
  };

  renderCompareBar = () => {
    this.compareBarList.innerHTML = '';
    this.products.forEach((handle) => this.addProductToBar(handle, false));
  };

  addProductToBar = async (handle, animate = true) => {
    if (!this.compareBarList) return;

    // Check if the product is already in the bar
    const existingItem = this.compareBarList.querySelector(`[data-handle="${handle}"]`);
    if (existingItem) return;

    const productData = await this.fetchProductData(handle);
    if (!productData) return;

    const item = document.createElement('li');
    item.className = `bt-compare-bar__item`;
    item.dataset.handle = handle;

    item.innerHTML = `
      <img src="${productData.featured_image}" alt="${productData.title}">
      <span class="title">${productData.title}</span>
      <button class="bt-remove-product-btn" data-product-handle="${handle}">${this.removeIcon}</button>
    `;

    this.compareBarList.appendChild(item);
  };

  removeProductFromBar = (handle) => {
    const item = this.compareBarList.querySelector(`[data-handle="${handle}"]`);
    if (item) {
      item.remove();
    }
  };

  fetchProductData = async (handle) => {
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) throw new Error('Network response was not ok.');
      return await response.json();
    } catch (error) {
      console.error('There was a problem with the fetch operation:', error);
      return null;
    }
  };

  addEventToBarButtons = () => {
    // Clear All
    const clearBtn = this.compareBar.querySelector(this.selectors.compareBarClear);
    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        this.products.forEach((handle) => this.removeFromCompare(handle));
        this.products = [];
        this.saveToStorage();
        this.renderCompareBar();
        this.updateCompareCount();
        this.removeAddedClassForAllCompareBtn();
      });
    }

    // Individual Remove
    addEventDelegate({
      scope: this.compareBarList,
      selector: '.bt-remove-product-btn',
      handler: (e, btn) => {
        const handle = btn.dataset.productHandle;
        this.removeFromCompare(handle);
        this.updateCompareCount();

        // Un-toggle the button on the page
        document
          .querySelectorAll(`${this.selectors.compareButton}[data-product-handle="${handle}"]`)
          .forEach((btnOnPage) => {
            if (btnOnPage.classList.contains(this.addedClass)) {
              this.toggleButtonState(btnOnPage, false, false);
            }
          });
      },
    });

    const collapseCompareBarBtn = this.compareBar.querySelector(this.selectors.collapseCompareBarBtn);
    if (collapseCompareBarBtn) {
      collapseCompareBarBtn.addEventListener('click', () => {
        this.compareBar.classList.remove('is-expanded');
      });
    }

    const expandCompareBarBtn = this.compareBar.querySelector(this.selectors.expandCompareBarBtn);
    if (expandCompareBarBtn) {
      expandCompareBarBtn.addEventListener('click', () => {
        this.compareBar.classList.add('is-expanded');
      });
    }
  };
}

UtenzoTheme.CompareProduct = new CompareProduct();
